import { createContext, PropsWithChildren, useContext, useEffect, useState } from "react"
import { Account } from "./types"
import { getAccount } from "./bank-manager.service"
import { JSONPath } from "jsonpath-plus";
import fr from './translations/fr.json'
import en from './translations/en.json'
import humanformat from 'human-format'


function t(key: string, currentLanguage = "fr") {
    return JSONPath({ path: key, json: currentLanguage === 'fr' ? fr : currentLanguage === 'en' ? en : fr });
}

export const BankManagerAccounContext = createContext<{ refresh: () => Promise<void>, account: Account | null }>({
    refresh: async () => { return },
    account: null
})

export function BankManagerAccount({ children }: PropsWithChildren) {
    const [account, setAccount] = useState<Account | null>(null)
    useEffect(() => {
        getAccount().then((account) => setAccount(account as Account))
    }, [])

    async function refresh() {
        const account = await getAccount()
        setAccount(account as Account)
        return;
    }

    return <BankManagerAccounContext.Provider value={{
        account,
        refresh
    }}>
        {children}
    </BankManagerAccounContext.Provider>
}


export interface BankManagerAccountBalanceNavProps {
    currentLanguage: 'fr' | 'en'
}

export function BankManagerAccountBalanceNav({
    currentLanguage = 'fr'
}: BankManagerAccountBalanceNavProps) {
    const { account } = useContext(BankManagerAccounContext)

    return <div className="text-white d-flex align-items-center justify-content-center pr-8">
        <span className="fs-5 fw-bold"> {humanformat(account?.balance || 0)} {t("credits", currentLanguage)}</span>
    </div>

}